import React from 'react';

import './Footer.css';

export default function Footer() {
  return (
    <div className="Footer">
      <div>
        The Nilito Carlino Foundation | PO Box 87, Attleboro, MA 02703
      </div>
      <div>Copyright &#169; 2021-2026</div>
    </div>
  );
}
